import { services } from '@octadesk-tech/services'
import { getParameterHeaders } from './headers'
import store from '@/store'

const getClient = () => {
  const headers = getParameterHeaders()
  return services.createClient('widgetBff', { headers })
}

export const log = message =>
  getClient().then(client => client.post('log', { message }))

export const hit = () =>
  getClient()
    .then(client =>
      client.get('hit', {
        params: {
          sd: store.getters.company,
          options: JSON.stringify(store.getters.options)
        }
      })
    )
    .catch(err => console.error(`error to call widget hit`, err))

export const validate = () =>
  getClient().then(client =>
    client
      .get('validate', {
        params: {
          sd: store.getters.company
        }
      })
      .catch(() => {
        console.warn(
          `Your Octadesk account "${store.getters.company}" is unavailable. Please, contact suporte@octadesk.com.`
        )
        throw new Error(`account "${store.getters.company}" is unavailable`)
      })
  )
